import React from 'react'

import { Controller, useFormContext } from 'react-hook-form'

import { FormControl } from '@tribeplatform/react-ui-kit/FormControl'
import {
  LabelPicker,
  LabelPickerProps,
} from '@tribeplatform/react-ui-kit/LabelPicker'

import { FormFieldProps, Optional } from '../typings.js'

export function FormLabelPicker({
  name,
  validation,
  label,
  helperText,
  value: fieldValue,
  onChange: fieldOnChange,
  ...rest
}: FormFieldProps<Optional<LabelPickerProps, 'value'>>) {
  const { control } = useFormContext()

  return (
    <Controller
      control={control}
      name={name}
      rules={validation}
      defaultValue={[]}
      render={({
        field: { onChange, value },
        fieldState: { error, invalid },
      }) => {
        return (
          <div>
            {label ? (
              <FormControl.Label htmlFor={name}>{label}</FormControl.Label>
            ) : null}
            <div className="mt-1">
              <LabelPicker
                {...rest}
                invalid={invalid}
                value={fieldValue ?? value}
                onChange={value => {
                  onChange(value)
                  if (typeof fieldOnChange === 'function') {
                    fieldOnChange(value)
                  }
                }}
              />
              <FormControl.Meta
                {...{
                  helperText,
                  invalid,
                  error: error?.message,
                }}
              />
            </div>
          </div>
        )
      }}
    />
  )
}
